import { IconButton, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import EditIcon from "assets/icons/EditIcon";
// import OpenEyeIcon from "assets/icons/OpenEyeIcon";
import { FC, useContext, useMemo, useState } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { useDeleteQuestionMutation } from "@generated/graphql";
import { ConfirmModalContext } from "context/confirmModalContext";
import { QuestionItemType } from "pages/Skill/view/types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { parseApolloError } from "helpers/errorsParser";
import ROUTES from "constants/routes";
import { RefetchFunction } from "@apollo/client/react/hooks/useSuspenseQuery";
import qs from "qs";
import QuestionImgButton from "./QuestionImgModal";

interface ActionButtonsProps {
  question: QuestionItemType;
  refetch?: RefetchFunction<any, any>;
  navigateToQuestionSearch?: string;
}

const ActionButtons: FC<ActionButtonsProps> = ({ question, refetch, navigateToQuestionSearch }) => {
  const isConfirm = question.confirmation;
  const { handleOpen } = useContext(ConfirmModalContext);
  const { addToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);

  const [openImgModal, setOpenImgModal] = useState<boolean>();

  const [deleteQuestion, { loading: deleteLoading }] = useDeleteQuestionMutation();

  const handleDelete = () => {
    handleOpen({
      title: isConfirm ? "Вы уверены, что хотите отклонить вопрос?" : "Вы уверены, что хотите удалить вопрос?",
      actionButtonText: isConfirm ? "Отклонить" : "Удалить",
      loading: deleteLoading,
      handleClick: async () =>
        deleteQuestion({
          variables: {
            questionId: question.id,
          },
        })
          .then(() => {
            if (refetch) refetch();
            addToast({ type: ToastTypeEnum.SUCCESS });
          })
          .catch((e) => {
            parseApolloError(e, { addToast });
          }),
    });
  };

  const navigateToQuestion = () => {
    setSearchParams(qs.stringify({ ...params, questionId: question.id }), { replace: true });
    // TODO: как-будто костыль, но нужно для сохранения состояния прокрутки.
    // Возможно в последствии сохраненять состояние прокрутки не по click, а на scroll
    setTimeout(() => {
      navigate({
        pathname: `/${ROUTES.QUESTION}/view/${question.id}`,
        search: navigateToQuestionSearch,
      });
    });
  };

  return (
    <Stack
      spacing={0.5}
      sx={{
        top: 16,
        right: -8,
        position: "absolute",
      }}>
      {!question.confirmation && (
        <IconButton onClick={handleDelete}>
          <Close sx={{ color: "text.disabled", width: 20, height: 20 }} />
        </IconButton>
      )}
      <IconButton onClick={navigateToQuestion}>
        <EditIcon sx={{ color: "text.disabled", width: 20, height: 20 }} />
      </IconButton>
      {/* <IconButton onClick={() => setOpenImgModal(true)}>
        <OpenEyeIcon sx={{ color: "text.disabled", width: 24, height: 24 }} />
      </IconButton> */}
      {openImgModal && (
        <QuestionImgButton
          open={openImgModal}
          onClose={() => setOpenImgModal(false)}
          questionId={question.id}
        />
      )}
    </Stack>
  );
};

export default ActionButtons;
